import React from 'react';
import { RiShareLine as ShareIcon } from 'react-icons/ri';

export default [
  {
    collapse: true,
    name: 'Sách điện tử (offline)',
    // href: 'https://cdn.sachso.edu.vn/ebooks-offline/SachSoOffline.zip',
    icon: 'fas fa-book text-yellow',
    roles: ['teacher'],
    sortOrder: 1,
    showInSidebar: true,
    state: 'lms/ebooks-offline',
    allowedUsers: ['testitdn@gmail.com', 'admin@gmail.com'],
    views: [
      {
        path: '/ebooks-offline',
        layout: '/lms',
        exact: true,
        roles: ['authenticated'],
      },
      {
        // path: '/ebooks-offline/dictionary',
        name: 'Phiên bản dành cho Windows 7',
        miniName: 'D',
        href: 'https://cdn.sachso.edu.vn/ebooks-offline/SachSoOffline.exe',
        icon: <i className='fab fa-windows' style={{ color: '#21a7ff' }}></i>,
        // layout: '/lms',
        // exact: true,
        // roles: ['authenticated'],
        showInSidebar: true,
        sortOrder: 0,
        download: 1,
      },
      {
        // path: '/ebooks-offline/translate',
        name: 'Phiên bản dành cho Windows 10',
        miniName: 'D',
        href: 'https://cdn.sachso.edu.vn/ebooks-offline/win10/SachSoOffline.exe',
        icon: <i className='fab fa-windows' style={{ color: '#21a7ff' }}></i>,
        // layout: '/lms',
        // exact: true,
        // roles: ['authenticated'],
        showInSidebar: true,
        sortOrder: 1,
        download: 2,
      },
    ],
  },

  // phát triển chuyên môn nghiệp vụ
  {
    path: '/teacher/files',
    name: 'Chuyên môn nghiệp vụ',
    miniName: 'C',
    component: React.lazy(() => import('pages/Teacher/Files')),
    icon: <ShareIcon className='text-red' size={20} />,
    layout: '/lms',
    exact: true,
    roles: ['teacher'],
    showInSidebar: true,
    sortOrder: 4,
  },

  // BEGIN: CLASSWORK - ASSIGNMENTS
  {
    path: '/teacher/classes/:classId/classwork/assignments/add',
    component: React.lazy(() => import('pages/Teacher/Classwork/Assignments/AddOrEdit')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },

  {
    path: '/teacher/classes/:classId/classwork/assignments/:assignmentId/edit/:exerciseType',
    component: React.lazy(() => import('pages/Teacher/Classwork/Assignments/AddOrEdit')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },

  {
    path: '/teacher/classes/:classId/classwork/assignments/:assignmentId/details/:exerciseType',
    component: React.lazy(() => import('pages/Teacher/Classwork/Assignments/Details')),
    layout: '/lms',
    exact: true,
    roles: ['teacher', 'administrator'],
  },
  // {
  //   path: '/admin/test-bank',
  //   name: 'Ngân hàng đề kiểm tra',
  //   miniName: 'C',
  //   icon: <MdDone size={20} className='tw-text-green-600' />,
  //   component: React.lazy(() => import('pages/TestBank/TestBank')),
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['teacher'],
  //   showInSidebar: true,
  //   sortOrder: 3,
  //   strictedAllowedUsers: ['testitdn@gmail.com', 'admin@gmail.com'],
  // },
  // {
  //   path: '/admin/import-question',
  //   name: 'Quản lý câu hỏi',
  //   miniName: 'C',
  //   icon: '	fas fa-question',
  //   component: React.lazy(() => import('pages/Administration/ImportQuestion')),
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['teacher'],
  //   // type: ['administrationRouters'],
  //   showInSidebar: true,
  //   sortOrder: 2,
  //   strictedAllowedUsers: ['testitdn@gmail.com', 'admin@gmail.com'],
  // },
  // END: CLASSWORK
];
